/**
 * API response'larındaki key'leri normalize eder
 * Hem büyük hem küçük harfle gelen field'ları düzgün şekilde handle eder
 */

/**
 * Bir nesnenin tüm key'lerini camelCase'e çevirir
 * @param {Object} obj - Normalize edilecek obje
 * @returns {Object} Normalize edilmiş obje
 */
export const normalizeKeys = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => normalizeKeys(item));
  }

  const normalized = {};
  Object.keys(obj).forEach(key => {
    // İlk harfi küçük yap (camelCase)
    const normalizedKey = key.charAt(0).toLowerCase() + key.slice(1);
    normalized[normalizedKey] = normalizeKeys(obj[key]);
  });

  return normalized;
};

/**
 * Response data'yı normalize eder - hem EtData hem etData'yı kontrol eder
 * @param {Object} response - Axios response objesi
 * @returns {Array} Normalize edilmiş data array
 */
export const normalizeResponseData = (response) => {
  const data = response?.data?.EtData ?? response?.data?.etData ?? response?.data;
  return Array.isArray(data) ? normalizeKeys(data) : [];
};

/**
 * Belirli field'lar için fallback değer sağlar
 * @param {Object} obj - Kontrol edilecek obje
 * @param {String} fieldName - Field adı (büyük harfle başlayan)
 * @returns {Any} Field değeri
 */
export const getFieldValue = (obj, fieldName) => {
  if (!obj) return null;
  
  // Önce orijinal isimle dene
  if (obj[fieldName] !== undefined) return obj[fieldName];
  
  // Sonra küçük harfle başlayanı dene
  const lowerFieldName = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
  if (obj[lowerFieldName] !== undefined) return obj[lowerFieldName];
  
  return null;
};
